import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  connect () {
    this.tooltipInstance = new bootstrap.Tooltip(this.element);
  }

  disconnect () {
    this.tooltipInstance.dispose();
  }
}
